// Taxonomy labels are authored display data. Strip structural numbering only;
// recasing here corrupts meaningful acronyms such as AI/ML, RAM and ABAC.
export const displayTaxonomyName = (value = "") => (
  String(value || "")
    .replace(/^\s*Domain\s+\d+(?:\.\d+)*\s*:\s*/i, "")
    .replace(/^\s*\d{1,2}(?:\.\d+)*[.):]?\s+(?=\S)/, "")
    .trim() || "Untitled"
);
